import Chart from '@components/charts/Chart';
import { Metric } from '@enums';
import { resolveBarColors } from '@utils';
import type { ChartData } from 'types/common';
import Styled from './HorizontalStackedBarChart.styled';

interface Props {
  body?: string;
  colors?: readonly string[];
  data: ChartData[];
  title?: string;
}

function HorizontalStackedBarChart({ body, colors, data, title }: Props) {
  const resolvedColors =
    colors && colors.length > 0 ? colors : resolveBarColors(data, false);

  return (
    <Styled.Root>
      {title ? <Styled.Title>{title}</Styled.Title> : null}
      {body ? <Styled.Body>{body}</Styled.Body> : null}
      <Styled.Chart>
        <Chart
          colors={resolvedColors}
          data={data}
          metric={Metric.AudiencePercentage}
          type="stacked-bar"
        />
      </Styled.Chart>
    </Styled.Root>
  );
}

export default HorizontalStackedBarChart;
